module.exports = __webpack_public_path__ + "img/terImg7.bc423eff.png";